<template>
  <!-- eslint-disable max-len -->
  <button class="add-link" @click="triggerClick">
    <svg
      class="add-link__image"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <defs>
        <path
          id="path-1"
          d="M10.75,9 L20,9 L20,10.75 L10.75,10.75 L10.75,20 L9,20 L9,10.75 L0,10.75 L0,9 L9,9 L9,0 L10.75,0 L10.75,9 Z"
        ></path>
      </defs>
      <g id="MVP-Web-Mobile---Sitters" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Availability---Mobile---Sitter---Edit-Complete" transform="translate(-325.000000, -617.000000)">
          <g id="Group-3" transform="translate(311.000000, 603.000000)">
            <g id="Glyphs-/-Web-/-Plus" transform="translate(14.000000, 14.000000)">
              <mask id="mask-2" fill="white">
                <use xlink:href="#path-1"></use>
              </mask>
              <use id="Mask" fill="#FFFFFF" fill-rule="nonzero" xlink:href="#path-1"></use>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </button>
  <!-- eslint-enable max-len -->
</template>

<script lang="ts">
export default {
  name: 'AddButton',
  methods: {
    triggerClick() {
      this.$emit('click');
    },
  },
};
</script>
